<template>
  <b-modal
    id="view-transcript-modal"
    centered
    hide-footer
    title="Call Transcript"
  >
    <div v-if="callLog && callLog.transcript">
      <!-- If transcript is an object, show as bullet points -->
      <ul v-if="isObject(transcriptData)" class="list-unstyled mb-0">
        <li
          v-for="(value, key) in transcriptData"
          :key="key"
          class="mb-2"
        >
          <strong>{{ formatKey(key) }}:</strong>
          <span v-if="isObject(value) || isArray(value)">
            <ul class="mb-0 mt-1">
              <li
                v-for="(subVal, subKey) in value"
                :key="subKey"
              >
                {{ subVal }}
              </li>
            </ul>
          </span>
          <span v-else>{{ value }}</span>
        </li>
      </ul>

      <!-- If transcript is a string, show as is -->
      <pre
        v-else
        style="white-space: pre-wrap;"
        class="mb-0"
      >{{ transcriptData }}</pre>
    </div>

    <p v-else class="text-muted">No transcript available.</p>
  </b-modal>
</template>

<script>
export default {
  props: { callLog: Object },

  computed: {
    transcriptData() {
      if (!this.callLog || !this.callLog.transcript) return null;

      const t = this.callLog.transcript;

      // If already an object, return it
      if (typeof t === 'object' && t !== null) return t;

      // If string, try to parse as JSON
      if (typeof t === 'string') {
        try {
          const parsed = JSON.parse(t);
          if (typeof parsed === 'object' && parsed !== null) return parsed;
        } catch (e) {
          // Not valid JSON, return raw string
        }
        return t;
      }

      return String(t);
    },
  },

  methods: {
    isObject(val) {
      return val !== null && typeof val === 'object' && !Array.isArray(val);
    },
    isArray(val) {
      return Array.isArray(val);
    },
    formatKey(key) {
      // Convert snake_case or camelCase to Title Case
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .replace(/^./, str => str.toUpperCase());
    },
  },
};
</script>